import { getProviderRankingsApiRequest } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const GET_PROVIDER_RANKINGS = { entity: 'GET_PROVIDER_RANKINGS', action: Action.GET_ONE };

export const getProviderRankings = () => async dispatch =>
  execute(dispatch, () => getProviderRankingsApiRequest(), GET_PROVIDER_RANKINGS, false, true);

export const providerRankingsReducers = {
  all: basicReducer(GET_PROVIDER_RANKINGS),
};
